import Component from '../Component';
import Icon from './Icon';
export default class DetailedDropdownItem extends Component {
  view() {
    return m("button", {
      type: "button",
      className: "DetailedDropdownItem hasIcon",
      onclick: this.attrs.onclick
    }, m("span", {
      className: "DetailedDropdownItem-checkIcon"
    }, this.attrs.active && m(Icon, {
      name: "fas fa-check",
      className: "Button-icon"
    })), m("span", {
      className: "DetailedDropdownItem-content"
    }, typeof this.attrs.icon === 'string' ? m(Icon, {
      name: this.attrs.icon,
      className: "Button-icon"
    }) : this.attrs.icon, m("span", {
      className: "DetailedDropdownItem-label"
    }, m("strong", null, this.attrs.label), m("span", {
      className: "DetailedDropdownItem-description"
    }, this.attrs.description))));
  }
}
flarum.reg.add('core', 'common/components/DetailedDropdownItem', DetailedDropdownItem);